import {useCurrentMaterialStorages, isStorageWithMaterialGuard} from '@domain/material-storage'
import {MaterialType} from '@domain/materials'
import {useEffect} from 'react'
import {Outlet} from 'react-router'

import {StockActionHeader} from '../components'
import {useSearchParams} from '../hooks'
import {PlannerPageLayout, StockPageLayout} from '../layouts'

type StockPageProps = {
  title?: string
  plantId: string
}

export const StockPage = ({title, plantId}: StockPageProps) => {
  const {data: storagesWithMaterial} = useCurrentMaterialStorages({
    plantId: plantId,
    options: {select: (storages) => storages.filter(isStorageWithMaterialGuard), throwOnError: true}
  })
  const [obtainedParams, setSearchParams] = useSearchParams('materialType')
  const materialType = obtainedParams.materialType

  useEffect(() => {
    if (!materialType) {
      setSearchParams({materialType: MaterialType.Cement as string})
    }
  }, [materialType, setSearchParams])

  if (!storagesWithMaterial || !materialType) {
    return <PlannerPageLayout />
  }

  return (
    <StockPageLayout
      title={title}
      headerActionContent={<StockActionHeader />}
      data-test-id="page_stock"
    >
      <Outlet />
    </StockPageLayout>
  )
}
